import { useCollaboratorsAcceptEventAdminInviteMutation } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { useToast } from '@withjoy/joykit';
import { WarningTriangle } from '@withjoy/joykit/icons';
import React from 'react';

export const useAcceptCollaborationInvite = () => {
  const [mutation] = useCollaboratorsAcceptEventAdminInviteMutation();
  const { tq } = useTranslation('collaboration');
  const { toast } = useToast();

  const acceptInvite = async (inviteUUID: string) => {
    const response = await mutation({
      variables: {
        acceptCollaborationInviteId: inviteUUID,
      },
    });

    if (response.errors || !response.data?.acceptCollaborationInvite || !response.data.acceptCollaborationInvite.event) {
      toast(tq`Error accepting invite. Please contact customer support.`, { icon: <WarningTriangle /> });
      return null;
    }

    return response.data.acceptCollaborationInvite;
  };

  return { acceptInvite };
};
